var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgChart = function SvgChart(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 29.5625,
    y1: 134.375,
    x2: 29.5625,
    y2: 150.153305,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(77.64706%,73.725492%,95.294118%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 67.1875,
    y1: 110.636307,
    x2: 67.1875,
    y2: 149.027252,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(77.64706%,73.725492%,95.294118%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 104.8125,
    y1: 129.894943,
    x2: 104.8125,
    y2: 148.712814,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(77.64706%,73.725492%,95.294118%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 142.4375,
    y1: 86.448807,
    x2: 142.4375,
    y2: 149.661499,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(77.64706%,73.725492%,95.294118%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 67.1875,
    y1: 42.551189,
    x2: 67.1875,
    y2: 53.75,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 142.4375,
    y1: 28.667561,
    x2: 142.4375,
    y2: 37.189629,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear6",
    gradientUnits: "userSpaceOnUse",
    x1: 29.5625,
    y1: 17.917561,
    x2: 29.5625,
    y2: 154.085129,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear7",
    gradientUnits: "userSpaceOnUse",
    x1: 67.1875,
    y1: 17.917561,
    x2: 67.1875,
    y2: 154.085129,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear8",
    gradientUnits: "userSpaceOnUse",
    x1: 104.8125,
    y1: 17.917561,
    x2: 104.8125,
    y2: 154.085129,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear9",
    gradientUnits: "userSpaceOnUse",
    x1: 142.4375,
    y1: 17.917561,
    x2: 142.4375,
    y2: 154.085129,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear10",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 17.917561,
    x2: 86,
    y2: 154.085129,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface9085395"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 7.8125 39.84375 L 9.375 39.84375 L 9.375 42.96875 L 7.8125 42.96875 Z M 7.8125 39.84375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 18.75 32.03125 L 20.3125 32.03125 L 20.3125 42.96875 L 18.75 42.96875 Z M 18.75 32.03125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 29.6875 38.28125 L 31.25 38.28125 L 31.25 42.96875 L 29.6875 42.96875 Z M 29.6875 38.28125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 40.625 25.78125 L 42.1875 25.78125 L 42.1875 42.96875 L 40.625 42.96875 Z M 40.625 25.78125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear4)"
    },
    d: "M 19.53125 12.890625 C 18.882812 12.890625 18.359375 13.414062 18.359375 14.0625 C 18.359375 14.710938 18.882812 15.234375 19.53125 15.234375 C 20.179688 15.234375 20.703125 14.710938 20.703125 14.0625 C 20.703125 13.414062 20.179688 12.890625 19.53125 12.890625 Z M 19.53125 12.890625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear5)"
    },
    d: "M 41.40625 8.203125 C 40.757812 8.203125 40.234375 8.726562 40.234375 9.375 C 40.234375 10.023438 40.757812 10.546875 41.40625 10.546875 C 42.054688 10.546875 42.578125 10.023438 42.578125 9.375 C 42.578125 8.726562 42.054688 8.203125 41.40625 8.203125 Z M 41.40625 8.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear6)"
    },
    d: "M 10.9375 33.59375 L 6.25 33.59375 C 5.386719 33.59375 4.6875 34.292969 4.6875 35.15625 L 4.6875 44.53125 L 12.5 44.53125 L 12.5 35.15625 C 12.5 34.292969 11.800781 33.59375 10.9375 33.59375 Z M 10.9375 35.15625 L 10.9375 36.71875 L 6.25 36.71875 L 6.25 35.15625 Z M 6.25 42.96875 L 6.25 38.28125 L 10.9375 38.28125 L 10.9375 42.96875 Z M 6.25 42.96875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear7)"
    },
    d: "M 21.875 25.78125 L 17.1875 25.78125 C 16.324219 25.78125 15.625 26.480469 15.625 27.34375 L 15.625 44.53125 L 23.4375 44.53125 L 23.4375 27.34375 C 23.4375 26.480469 22.738281 25.78125 21.875 25.78125 Z M 21.875 27.34375 L 21.875 28.90625 L 17.1875 28.90625 L 17.1875 27.34375 Z M 17.1875 42.96875 L 17.1875 30.46875 L 21.875 30.46875 L 21.875 42.96875 Z M 17.1875 42.96875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear8)"
    },
    d: "M 32.8125 32.03125 L 28.125 32.03125 C 27.261719 32.03125 26.5625 32.730469 26.5625 33.59375 L 26.5625 44.53125 L 34.375 44.53125 L 34.375 33.59375 C 34.375 32.730469 33.675781 32.03125 32.8125 32.03125 Z M 32.8125 33.59375 L 32.8125 35.15625 L 28.125 35.15625 L 28.125 33.59375 Z M 28.125 42.96875 L 28.125 36.71875 L 32.8125 36.71875 L 32.8125 42.96875 Z M 28.125 42.96875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear9)"
    },
    d: "M 43.75 19.53125 L 39.0625 19.53125 C 38.199219 19.53125 37.5 20.230469 37.5 21.09375 L 37.5 44.53125 L 45.3125 44.53125 L 45.3125 21.09375 C 45.3125 20.230469 44.613281 19.53125 43.75 19.53125 Z M 43.75 21.09375 L 43.75 22.65625 L 39.0625 22.65625 L 39.0625 21.09375 Z M 39.0625 42.96875 L 39.0625 24.21875 L 43.75 24.21875 L 43.75 42.96875 Z M 39.0625 42.96875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear10)"
    },
    d: "M 39.882812 12.96875 C 40.351562 13.171875 40.867188 13.28125 41.40625 13.28125 C 43.558594 13.28125 45.3125 11.527344 45.3125 9.375 C 45.3125 7.222656 43.558594 5.46875 41.40625 5.46875 C 39.253906 5.46875 37.5 7.222656 37.5 9.375 C 37.5 10.425781 37.921875 11.375 38.597656 12.078125 L 32.546875 20.144531 C 31.945312 19.761719 31.234375 19.53125 30.46875 19.53125 C 29.535156 19.53125 28.6875 19.875 28.015625 20.421875 L 22.8125 16.164062 C 23.203125 15.554688 23.4375 14.835938 23.4375 14.0625 C 23.4375 11.910156 21.683594 10.15625 19.53125 10.15625 C 17.378906 10.15625 15.625 11.910156 15.625 14.0625 C 15.625 14.726562 15.808594 15.339844 16.101562 15.890625 L 10.960938 20.351562 C 10.300781 19.84375 9.488281 19.53125 8.59375 19.53125 C 6.441406 19.53125 4.6875 21.285156 4.6875 23.4375 C 4.6875 25.589844 6.441406 27.34375 8.59375 27.34375 C 10.746094 27.34375 12.5 25.589844 12.5 23.4375 C 12.5 22.742188 12.300781 22.097656 11.980469 21.53125 L 17.097656 17.09375 C 17.765625 17.632812 18.605469 17.96875 19.53125 17.96875 C 20.34375 17.96875 21.097656 17.71875 21.722656 17.292969 L 27.027344 21.628906 C 26.738281 22.171875 26.5625 22.78125 26.5625 23.4375 C 26.5625 25.589844 28.316406 27.34375 30.46875 27.34375 C 32.621094 27.34375 34.375 25.589844 34.375 23.4375 C 34.375 22.617188 34.121094 21.859375 33.6875 21.230469 Z M 41.40625 7.03125 C 42.699219 7.03125 43.75 8.082031 43.75 9.375 C 43.75 10.667969 42.699219 11.71875 41.40625 11.71875 C 40.113281 11.71875 39.0625 10.667969 39.0625 9.375 C 39.0625 8.082031 40.113281 7.03125 41.40625 7.03125 Z M 8.59375 25.78125 C 7.300781 25.78125 6.25 24.730469 6.25 23.4375 C 6.25 22.144531 7.300781 21.09375 8.59375 21.09375 C 9.886719 21.09375 10.9375 22.144531 10.9375 23.4375 C 10.9375 24.730469 9.886719 25.78125 8.59375 25.78125 Z M 19.53125 16.40625 C 18.238281 16.40625 17.1875 15.355469 17.1875 14.0625 C 17.1875 12.769531 18.238281 11.71875 19.53125 11.71875 C 20.824219 11.71875 21.875 12.769531 21.875 14.0625 C 21.875 15.355469 20.824219 16.40625 19.53125 16.40625 Z M 30.46875 25.78125 C 29.175781 25.78125 28.125 24.730469 28.125 23.4375 C 28.125 22.144531 29.175781 21.09375 30.46875 21.09375 C 31.761719 21.09375 32.8125 22.144531 32.8125 23.4375 C 32.8125 24.730469 31.761719 25.78125 30.46875 25.78125 Z M 30.46875 25.78125 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chart.19c35be1.svg";
export { ForwardRef as ReactComponent };